<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>Fee Structure Installment Details </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required @click="putnull()" v-model="sel_ay_data"
                        return-object :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-btn class="mt-6 button" @click="onload()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
            <span v-if="installment_details != ''">
                <v-col cols="12" sm="12" md="12" v-for="inst in installment_details" :key="inst.std_id">
                    <v-row class="toolbar" dense justify="center">
                        <center>
                            <strong>Standard:: {{ inst.std_name }}</strong>
                        </center>
                    </v-row>
                    <span v-if="inst.fee_str_size != 0">
                        <v-expansion-panels focusable class="box">
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <center><strong>Fee Structure</strong> <br /></center>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-col cols="12" sm="12" md="12">
                                        <center>
                                            <v-btn small class="button"
                                                @click="getStatus(inst.std_id, inst.ay_id)">Learner Status</v-btn>
                                        </center>
                                        <v-simple-table dense class="elevation-1 mytable">
                                            <template v-slot:default>
                                                <thead class="toolbar">
                                                    <tr>
                                                        <th>Installment</th>
                                                        <th>Quota</th>
                                                        <th>Due Date</th>
                                                        <th>Fine</th>
                                                        <th>Is-Approved</th>
                                                        <th>Components</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-for="fi in inst.fee_structure" :key="fi.id">
                                                    <tr>
                                                        <td>
                                                            <strong>{{ fi.feesinstallmentacademicyear }}</strong>
                                                        </td>
                                                        <!-- <td class="toolbar" v-if="fi.quota == 'RTE'">
                                                          {{ fi.quota }}
                                                      </td>
                                                      <td v-if="fi.quota == 'General'">
                                                          {{ fi.quota }}
                                                      </td>
                                                      <td style="background-color: aqua;" v-if="fi.quota == 'SRES Staff'">
                                                          {{ fi.quota }}
                                                      </td>
                                                      <td style="background-color: aquamarine;" v-if="fi.quota == 'SRES WARD'">
                                                          {{ fi.quota }}
                                                      </td>
                                                      <td style="background-color: cadetblue;" v-if="fi.quota == 'SRES WARD BI-FOCAL'">
                                                          {{ fi.quota }}
                                                      </td>
                                                      <td style="background-color: cornsilk;" v-if="fi.quota == 'BI-FOCAL'">
                                                          {{ fi.quota }}
                                                      </td> -->
                                                        <td>
                                                            {{ fi.quota }}
                                                        </td>
                                                        <td>{{ fi.due_date }}</td>
                                                        <td>{{ fi.fine }}</td>
                                                        <td>
                                                            <span v-if="fi.isapproved">
                                                                <v-icon class="mr-2 v-icon-size"
                                                                    color="success">mdi-check-circle-outline</v-icon>
                                                            </span>
                                                            <span v-else>
                                                                <v-icon class="mr-2 v-icon-size"
                                                                    color="error">mdi-close-circle-outline</v-icon>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <center>
                                                                <thead class="toolbar">
                                                                    <th v-for="com in fi.components" :key="com.id">
                                                                        {{ com.name }}
                                                                    </th>
                                                                </thead>
                                                <tbody>
                                                    <th v-for="com in fi.components" :key="com.id">
                                                        {{ com.amount }}
                                                    </th>
                                                </tbody>
                                                </center>
                                                </td>
                                                </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </span>
                    <span v-else>
                        <v-col cols="12" sm="12" md="12">
                            <v-row dense justify="center">
                                <span class="text-color"> Fee Structure not defined for this standard</span>
                            </v-row>
                        </v-col>
                    </span>
                </v-col>
            </span>
        </v-card>
        <v-dialog v-model="dialog" fullscreen>
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Learner Status </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog = false"><v-icon> mdi-close
                        </v-icon></v-btn>
                </v-toolbar>
                <v-card class="box">
                    <learner-fees-status :std_id="std_id" :ay_id="ay_id"></learner-fees-status>
                </v-card>
                <v-row justify="center">
                    <v-btn class="button" @click="close()">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import LearnerStatus from "./StandardLearnerFees";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
  export default {
      components: {
          "learner-fees-status": LearnerStatus,
          Breadcrumbs
      },
      data() {
          return {
              snackbar_msg: "",
              color: "",
              snackbar: false,
              overlay: false,
              search: null,
            //   extraBreadcrumbItems: [
                

            //   ],
            //   breadcrumbClass: "breadcrumb-style1",
              installment_details: [],
              dialog: false,
              std_id: null,
              ay_std_div_list: null,
              sel_ay_data: null,
              ay_id: null,
          };
      },
      watch: {
          overlay(val) {
              val = () => {
                  this.overlay = false;
              };
          },
      },
      methods: {
          putnull() {
              this.installment_details = [];
          },
          close() {
              this.std_id = null;
              this.dialog = false;
          },
          getStatus(item, ay_id) {
              this.std_id = item;
              this.ay_id = ay_id;
              this.dialog = true;
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          onload() {
              const data = {
                  ay: this.sel_ay_data.ay_id,
              };
              this.overlay = true;
              axios
                  .post("/InstallmentStructureDetails/getData", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.installment_details = res.data.installment_details;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },
          main() {
              axios
                  .post("/commonAPI/get_ay_std_div")
                  .then((res) => {
                      this.ay_std_div_list = res.data.data;
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  })
                  .finally(() => {});
          },
      },
      mounted() {
          this.main();
      },
  };
</script>
<style scoped>
  .text-color {
      font-weight: bold;
      color: red;
  }
  tr,
  td,
  th {
      border: 1px solid #ccc;
      text-align: center;
  }
  tr,
  tbody {
      border-bottom: 1px solid #ccc;
      border: 1px solid #ccc;
  }
  td {
      margin: 0.3rem !important;
      padding: 0.4rem !important;
  }
  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
      }
      td + td,
      th + th {
          width: auto;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      text-align: center;
  }
</style>
